import { render, staticRenderFns } from "./StoreInsights.vue?vue&type=template&id=1f46d3b4&"
import script from "./StoreInsights.vue?vue&type=script&lang=js&"
export * from "./StoreInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports